import React from "react";
import { caratNonEditableList } from "content/static";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EditInputs } from "../../../src/components/Pricing/EditInputs";
import { EditSelects } from "components/Pricing/EditSelects";

const handleBlur = (event) => {
  const enteredValue = parseFloat(event.target.value);
  if (enteredValue === 0) {
    event.target.style.color = "red";
  } else {
    event.target.style.color = "black";
  }
};

const PriceTableRow = ({
  handleLotList,
  setDeletestoneDetails,
  lotCodeList,
  stoneDetails,
  handleRHSRateChange,
  subIndex,
  handleMaxCtsChange,
  details,
  deletestoneDetails,
  handleChainStoneDelete,
  handleAddToRow,
}) => {
  const [lotCodeValue, setLotCodeValue] = React.useState({
    label: stoneDetails.lotCode,
    value: stoneDetails.lotCode,
  });
  const filterLotCode = (inputValue) => {
    return lotCodeList
      ?.filter(
        (i) =>
          typeof i.label === "string" &&
          i.label.toLowerCase().includes(inputValue.toLowerCase())
      )
      .slice(0, 200);
  };

  // const defaulValues = lotCodeList && lotCodeList.length > 0 && typeof lotCodeList[0].label === 'string'
  //   ? [{ label: lotCodeList.label, value: lotCodeList.value }]
  //   : [];

  const loadOptionsList = (inputValue, callback) => {
    // Check if inputValue length is greater than or equal to 3
    if (inputValue.length >= 1) {
      setTimeout(() => {
        callback(filterLotCode(inputValue));
      }, 1000);
    } else {
      // If length is less than 1, return an empty array
      callback([]);
    }
  };

  const temp = (inputValue, callback) => {
    loadOptionsList(inputValue, callback);
  };

  return (
    <>
      <tr
        className="pricingTable tr-pricing"
        style={
          {
            // display: (stoneDetails.ppwt === -1 || stoneDetails.comName === "Labour" ) ? "none" : "table-row",
          }
        }
        key={stoneDetails._id}
      >
        <td className="">
          <div className="additional-details">
            <div className="d-flex">
              {stoneDetails.comName}
              <div
                style={{ color: "red", fontSize: "12px", paddingTop: "2px" }}
              >
                <span>
                  &nbsp;
                  {stoneDetails.comName === "Metal" && stoneDetails.sieveSize
                    ? `(${stoneDetails.sieveSize})`
                    : ""}
                </span>
                <span>
                  {stoneDetails.comName === "Metal" && stoneDetails.mmSize
                    ? `(${stoneDetails.mmSize})`
                    : ""}
                </span>
              </div>

              {/* <span>
                <ActionBtn
                  deleteAction={
                    (stoneDetails.comName === "Finding" ||
                      stoneDetails.comName === "Chain") &&
                    (() =>
                      handleChainStoneDelete(stoneDetails, deletestoneDetails))
                  }
                />
              </span> */}
               <span
                style={{
                  display: stoneDetails.comName === "Chain" || stoneDetails.comName === "Finding" ? "block" : "none",
                }}
              >
                <ActionBtn
                  deleteAction={() =>
                    handleChainStoneDelete(stoneDetails, deletestoneDetails)
                  }
                  addAction={() =>{
                    handleAddToRow(stoneDetails, deletestoneDetails)
                  }}
                />
              </span>
            </div>

            {stoneDetails.comName !== "Labour" ? (
              <div
                style={{
                  color: "#900074",
                  fontSize: "12px",
                  textTransform: "uppercase",
                }}
              >
                {stoneDetails.shapeCode}/{stoneDetails.colorCode}/
                {stoneDetails.cutCode}
              </div>
            ) : (
              // <div style={{  color: "#900074",fontSize: "12px"}}>
              //     {stoneDetails.shapeCode} / {stoneDetails.shapeCode} / {stoneDetails.settingType}
              //     {/* <div>{stoneDetails.cusmaster}</div> */}
              // </div>
              <></>
            )}
          </div>
        </td>
        <td>
          <input
            className="table_fix_text"
            type="text"
            style={{
              display: stoneDetails.comName === "Metal" ? "none" : "block",
            }}
            defaultValue={stoneDetails.sieveSize}
            disabled
          />
        </td>
        <td>
          <input
            className="table_fix_text"
            type="text"
            style={{
              display: stoneDetails.comName === "Metal" ? "none" : "block",
            }}
            defaultValue={stoneDetails.mmSize}
            disabled
          />
        </td>
        <td>
          <input
            className="table_fix_text"
            type="text"
            defaultValue={stoneDetails.ppwt}
            disabled
          />
        </td>
        <td>
          <input
            className="table_fix_text"
            type="text"
            defaultValue={stoneDetails.pcCount}
            disabled
          />
        </td>

        <td>
          <input
            className="table_fix_text"
            type="text"
            defaultValue={stoneDetails.settingType}
            style={{
              display: stoneDetails.comName !== "Diamond" ? "none" : "block",
            }}
            disabled
          />
        </td>
        <td className="">
          {stoneDetails.comName !== "Labour" && (
            <EditSelects
              cacheOptions
              className={"lotCode-widthSelect editable-pointer-events"}
              isSearchable={true}
              required
              value={lotCodeValue} // Use lotCodeValue state instead of stoneDetails.lotCode
              defaultValue={lotCodeValue} // Use lotCodeValue state instead of stoneDetails.lotCode
              onChange={async (newValue) => {
                // Update the lot code value state
                setLotCodeValue({
                  label: newValue.value,
                  value: newValue.value,
                });
                stoneDetails.lotCode = newValue.value;
                await handleMaxCtsChange(
                  newValue.value,
                  stoneDetails,
                  details,
                  deletestoneDetails,
                  setDeletestoneDetails,
                  "lotCode"
                );
              }}
              onFocus={() =>
                handleLotList(
                  stoneDetails?.rmId,
                  stoneDetails,
                  stoneDetails.comName,
                  stoneDetails.cutCode
                )
              }
              loadOptions={temp}
              defaultOptions
              style={{ zIndex: 0 }}
            />
          )}

          {/* {stoneDetails.lotCode}
         
          {// console.log("stoneDetails.lotCode", stoneDetails.lotCode)} */}
        </td>
        <td>
          <p
            className="table_fix_text"

            //onBlur={(event) => handleMaxCtsChange(event, stoneDetails, details)}
            //disabled={caratNonEditableList.find((state) => state === stoneDetails.comName)}
          >
            {stoneDetails.maxCts || 0}
          </p>
        </td>
        <td>
          <p className="table_fix_text text-right">
            {stoneDetails.lhsRate != null && stoneDetails.lhsRate !== 0
              ? parseFloat(stoneDetails.lhsRate)?.toFixed(2)
              : stoneDetails.lhsRate}
          </p>
        </td>
        <td>
          <p className="table_fix_text text-right">
            {stoneDetails.lhsAmt?.toFixed(2)}
          </p>
        </td>
        <td>
          <EditInputs
            // pointer={{cursor: "pointer"}}
            className={"form-control form-control-sm text-left "}
            stoneDetails={stoneDetails}
            defaultValue={stoneDetails.rhsMaxCts || 0}
            onBlur={(event) => {
              handleMaxCtsChange(
                event,
                stoneDetails,
                details,
                deletestoneDetails,
                setDeletestoneDetails,
                "rhsMaxCts"
              );
            }}
            disabled={caratNonEditableList.find(
              (state) => state === stoneDetails.comName
            )}
          />
        </td>

        <td>
          <EditInputs
            className={"form-control form-control-sm text-right"}
            stoneDetails={stoneDetails}
            // pointer={{cursor: "pointer"}}
            style={{
              color:
                stoneDetails.rhsRate === null ||
                stoneDetails.rhsRate === "0" ||
                stoneDetails.rhsRate === 0
                  ? "red"
                  : "black",
            }}
            type="text"
            defaultValue={stoneDetails.rhsRate}
            onBlur={(event) => {
              handleBlur(event, stoneDetails);
              handleRHSRateChange(event, stoneDetails, details);
            }}
          />
        </td>

        <td>
          <p className="table_fix_text text-right">
            {parseFloat(stoneDetails.rhsAmt?.toFixed(2))}
          </p>
        </td>
        <td>
          <p
            className="table_fix_text"
            style={{
              display: stoneDetails.cusmaster === "IKR06" ? "none" : "block",
            }}
          >
            {stoneDetails.cusmaster}
          </p>
        </td>
        <td>{stoneDetails.isClientStone}</td>
      </tr>
    </>
  );
};

// const Indicator = {
//     true: <FontAwesomeIcon icon={faArrowUp} className="px-2 text-success" />,
//     false: <FontAwesomeIcon icon={faArrowDown} className="px-2 text-danger" />,
// };

const ActionBtn = ({ deleteAction, addAction }) => (
  <>
    <FontAwesomeIcon
      type="button"
      data-toggle="modal"
      title="Delete metalLoss"
      data-target="#exampleModal"
      className="px-1 delete_chainStone"
      icon={faTrash}
      size="xs"
      onClick={deleteAction}
    />
     <FontAwesomeIcon
      type="button"
      data-toggle="modal"
      title="Delete metalLoss"
      data-target="#exampleModal"
      className="px-1 delete_chainStone"
      icon={faPlus}
      size="xs"
      onClick={addAction}
    />
  </>
);

export default PriceTableRow;
